export default __webpack_public_path__ + "static/media/Lindsey.1634b578.jpg";